/**
 * Factory functions for creating link cells
 */
import { dia, shapes } from '@joint/core'
import { Link, LinkType } from '@/models'
import GraphState from './graph-state'

const defaultLinkLineStyle = {
  connection: true,
  stroke: '#808080',
  strokeWidth: 2,
  targetMarker: {
    type: 'path',
    fill: '#808080',
    stroke: 'none',
    d: 'm 12 -6 L -3 0 L 12 5 L 9 0 z',
  },
}

const dashedLinkLineStyle = {
  strokeDasharray: '8 4',
  strokeDashoffset: 8,
  targetMarker: {
    d: 'M 10 -5 L 0 0 L 10 5 L 6 0 z',
  },
}

export const CustomLink = dia.Link.define(
  'custom.Link',
  {
    attrs: {
      line: defaultLinkLineStyle,
      wrapper: {
        connection: true,
        strokeWidth: 10,
        strokeLinejoin: 'round',
      },
    },
    connector: {
      name: 'straight',
      args: { cornerType: 'cubic', precision: 0, cornerRadius: 5 },
    },
    z: 2,
    weight: 1,
    minLen: 1,
    labelPosition: 'c',
    labelOffset: 10,
    labelSize: {
      width: 50,
      height: 30,
    },
  },
  {
    markup: [
      {
        tagName: 'path',
        selector: 'wrapper',
        attributes: {
          fill: 'none',
          cursor: 'pointer',
          stroke: 'transparent',
        },
      },
      {
        tagName: 'path',
        selector: 'line',
        attributes: {
          fill: 'none',
          'pointer-events': 'none',
        },
      },
    ],
  },
)

export function makeLink(
  model: Link | LinkType,
  source: dia.Cell,
  target: dia.Cell,
  opts?: { debug?: boolean; label?: string },
): shapes.standard.Link {
  const link = new CustomLink()

  link.source(source)
  link.target(target)

  if (Object.hasOwn(model, 'linkType')) {
    link.prop(GraphState.PROP_LINK, model)
  } else {
    link.prop(GraphState.PROP_LINK_TYPE, model)
  }

  // opts = { debug: true, ...opts }

  if (opts && opts.label) {
    link.appendLabel({ attrs: { text: { text: opts.label } } })
  }

  if (opts && opts.debug) {
    const sourceId =
      source.attributes.artifact !== undefined
        ? 'a ' + source.attributes.artifact.id
        : 'at ' + source.attributes.artifactType.id

    const targetId =
      target.attributes.artifact !== undefined
        ? 'a ' + target.attributes.artifact.id
        : 'at ' + target.attributes.artifactType.id

    const kindOfLink = Object.hasOwn(model, 'linkType') ? 'l' : 'lt'

    link.appendLabel({
      attrs: {
        text: { text: ` ${sourceId} -(${kindOfLink} ${model.id})-> ${targetId} ` },
      },
    })
  }
  if (
    target.attributes.artifactType?.artifactCount === 0 ||
    source.attributes.artifactType?.artifactCount === 0
  ) {
    link.attr({ line: { ...defaultLinkLineStyle, ...dashedLinkLineStyle } })
  }

  // link.router('manhattan', {})
  return link
}
